import React, { useState, useContext, useEffect } from "react"
import { AppContext } from "./index"
import CRUDaccion from "./CRUDaccion"

export default function Accion({ a }) {
    let { firebase } = useContext(AppContext)

    const [accion, setAccion] = useState(null)
    useEffect(() => { setAccion(firebase.accion(a)) }, [a, firebase])

    return (
        <div style={Smarco}>
            {accion && <CRUDaccion accion={accion} />}
        </div>
    )
}

const Smarco = {
    margin: "25px",
    width: "36.2%",
};